import React, { useState, useEffect } from "react";
import { Layout, Menu } from "antd";
import { Link } from "react-router-dom";
import { auth } from "../actions";
import { connect } from "react-redux";

import logo from "../assets/logo.png";
import logoCollapsed from "../assets/logo-collapsed.png";

// Custom sidebar icons
import homeIcon from "../assets/sidebar/home.png";
import projectsIcon from "../assets/sidebar/project.png";
import modulesIcon from "../assets/sidebar/module.png";
import documentsIcon from "../assets/sidebar/documents.png";
import settingsIcon from "../assets/sidebar/settings.png";
import "./sidebar.css";
import logoutIcon from "../assets/sidebar/logout.png";

const { Sider } = Layout;

const SidebarLayout = ({ onCollapse, logout }) => {
  const [tierData, setTierData] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  console.log("tier", tierData);

  useEffect(() => {
    const loadTierData = () => {
      const data = localStorage.getItem("tier_data");
      if (data) {
        try {
          setTierData(JSON.parse(data));
        } catch (e) {
          console.error("Failed to parse tier_data:", e);
        }
      }
    };

    loadTierData();

    window.addEventListener("tierDataUpdated", loadTierData);
    return () => {
      window.removeEventListener("tierDataUpdated", loadTierData);
    };
  }, []);

  const API_URL = "https://api.intensel.net/api/user/update_last_accessed/";

  const fetchLastAccessed = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.warn("No token found. User might not be logged in.");
      return;
    }

    const formData = new FormData();
    formData.append("path", window.location.pathname);

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          Authorization: `Token ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      console.log("Last accessed updated successfully:", data);
    } catch (error) {
      console.error("Error updating last accessed:", error);
    }
  };

  useEffect(() => {
    fetchLastAccessed();
    const intervalId = setInterval(fetchLastAccessed, 300000); // every 5 min
    return () => clearInterval(intervalId);
  }, []);

  const handleLogout = () => {
    logout();
  };

  const toggleSidebar = () => {
    const newCollapsed = !collapsed;
    setCollapsed(newCollapsed);
    if (onCollapse) onCollapse(newCollapsed);
  };

  const CustomTrigger = ({ collapsed, onClick }) => (
    <div
      onClick={onClick}
      style={{
        position: "absolute",
        right: -12,
        top: 24,
        width: 28,
        height: 28,
        background: "rgb(24, 32, 47)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        padding: "6px",
        cursor: "pointer",
        zIndex: 1,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        transition: "transform 0.3s",
        transform: collapsed ? "rotate(180deg)" : "none",
      }}
    >
      &lt;
    </div>
  );

  const renderIcon = (src) => (
    <img
      src={src}
      alt="icon"
      style={{
        width: 16,
        height: 40,
        objectFit: "contain",
        transition: "all 0.3s ease-in-out",
      }}
    />
  );

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={285}
      collapsedWidth={102}
      style={{
        backgroundColor: "rgb(24, 32, 47)",
        position: "fixed",
        height: "100vh",
      }}
    >
      <CustomTrigger collapsed={collapsed} onClick={toggleSidebar} />

      {/* Logo */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: collapsed ? "0.5rem" : "1.5rem",
        }}
      >
        <img
          src={collapsed ? logoCollapsed : logo}
          alt="Logo"
          style={{ transition: "all 0.2s" }}
        />
      </div>
      <div className="divider_sidebar"></div>

      {/* Main Menu */}
      <Menu
        theme="dark"
        mode="inline"
        style={{
          backgroundColor: "rgb(24, 32, 47)",
          border: "none",
        }}
        items={[
          {
            key: "home",
            icon: renderIcon(homeIcon),
            label: <Link to="/">Home</Link>,
          },
          {
            key: "projects",
            icon: renderIcon(projectsIcon),
            label: <Link to="/project">Projects</Link>,
          },
          {
            key: "modules",
            icon: renderIcon(modulesIcon),
            label: "Modules",
            children: [
              ...(tierData?.allowed_modules?.includes("physical_risk")
                ? [
                    {
                      key: "physical-risk",
                      label: <Link to="/location">Physical Risk</Link>,
                    },
                  ]
                : []),
              ...(tierData?.allowed_modules?.includes("transition_risk")
                ? [
                    {
                      key: "transition-risk",
                      label: <Link to="/transition">Transition Risk</Link>,
                    },
                  ]
                : []),
              ...(tierData?.allowed_modules?.includes("map")
                ? [
                    {
                      key: "map-module",
                      label: <Link to="/create-map">Map Module</Link>,
                    },
                    {
                      key: "district-map",
                      label: <Link to="/district">District Map</Link>,
                    },
                  ]
                : []),
            ].filter(Boolean),
          },
          {
            key: "documents",
            icon: renderIcon(documentsIcon),
            label: "Documents",
            children: [
              {
                key: "methodology",
                label: <Link to="/methodology">Climate Methodology</Link>,
              },
              {
                key: "adaptation_methodology",
                label: <Link to="/toolkit">Adaptation Methodology</Link>,
              },
              {
                key: "changelogs",
                label: <Link to="/changelog">Change logs</Link>,
              },
              {
                key: "faqs",
                label: <Link to="/faq">Faqs</Link>,
              },

              {
                key: "apidocs",
                label: (
                  <Link
                    to="#"
                    onClick={() =>
                      window.open(
                        "https://docs.intensel.net",
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    API Docs
                  </Link>
                ),
              },
            ],
          },
          {
            key: "settings",
            icon: renderIcon(settingsIcon),
            label: <Link to="/setup">Settings</Link>,
          },
        ]}
      />

      <div className="divider"></div>

      {/* Bottom Menu */}
      <Menu
        theme="dark"
        mode="inline"
        style={{
          backgroundColor: "rgb(24, 32, 47)",
          position: "absolute",
          bottom: "0",
          left: "-4px",
          padding: "2rem",
          width: "100%",
          border: "none",
        }}
        items={[
          {
            key: "logout",
            icon: renderIcon(logoutIcon),
            label: <span onClick={handleLogout}>Logout</span>,
            style: { color: "#fff" },
          },
        ]}
      />
    </Sider>
  );
};

const mapStateToProps = (state) => ({
  errors: state.auth.errors,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(auth.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarLayout);
